import {
    BitmapTextSpecification,
    Component,
    ContainerSpecification,
    createSprite,
    createTextWithFallback,
    SpriteSpecification,
} from '@1x2network/pixi_assets'
import { BitmapText, Container, Sprite, Text } from 'pixi.js'

/**
 * Counter that counts down from 15 to 0 when a cash symbol lands
 * to indicate how close the player is to the mega jackpot.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class MegaJackpotCounter extends Component<MegaJackpotCounterSpecification> {
    private text: Text | BitmapText
    private background: Sprite

    private max = 15
    private count = 0

    constructor(options: { spec: string | MegaJackpotCounterSpecification; parent?: Container }) {
        super(options)
        this.background = createSprite({ spec: this.specification.background, parent: this })
        this.background.setParent(this)
        this.background.position.set(this.specification.text.x, this.specification.text.y)
        this.text = createTextWithFallback({ spec: this.specification.text, parent: this })
    }

    public setCounter(value: number): void {
        this.count = value
        this.text.text = (this.max - this.count).toString()
    }

    public onCashSymbolLand(): void {
        this.setCounter(this.count + 1)
    }

    public get value(): number {
        return this.count
    }
}

export interface MegaJackpotCounterSpecification extends ContainerSpecification {
    background: SpriteSpecification
    text: BitmapTextSpecification
}
